import React from 'react';
import {
    Snackbar as MUISnackbar,
    SnackbarProps,
    IconButton,
    Box,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import styled from 'styled-components';

const CloseIcon = styled(ClearOutlinedIcon)`
    font-size: 2.2rem;
    fill: ${({ theme }) => theme.palette.background.paper};
`;

interface IProps extends SnackbarProps {
    variant: 'error' | 'success';
    onClose: () => void;
}

const BaseSnackbar = ({ message, variant, onClose, ...other }: IProps) => (
    <MUISnackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        ClickAwayListenerProps={{
            onClickAway: () => {},
        }}
        onClose={onClose}
        {...other}
    >
        <MuiAlert elevation={6} severity={variant} variant="filled">
            {message}
            <Box ml={8}>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
        </MuiAlert>
    </MUISnackbar>
);

export const Snackbar = styled(BaseSnackbar)`
    .MuiAlert-root {
        display: flex;
        align-items: center;
        padding: ${({ theme }) =>
            `${theme.spacing(4)}px ${theme.spacing(3)}px`};
        background-color: ${({ theme, variant }) =>
            variant === 'success'
                ? theme.palette.success.main
                : theme.palette.error.main};
        border-radius: 7px;
        font-weight: 700;
        font-size: ${({ theme }) => theme.typography.body1.fontSize};

        .MuiAlert-icon {
            font-size: 1.5em;
            padding: 0;
            margin-right: ${({ theme }) => `${theme.spacing(5)}px`};
        }

        .MuiAlert-message {
            display: flex;
            align-items: center;
            padding: 0;
        }

        .MuiIconButton-root {
            padding: 0;
        }
    }
`;
